'use client'

import { Search, X } from 'lucide-react'
import type { ReactNode } from 'react'

// A module body's toolbar (the design system's .ops-toolbar): the search
// input on the left, selects and filters on the right, a hairline below.
export function Toolbar({ children, end, className = '' }: { children?: ReactNode; end?: ReactNode; className?: string }) {
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 border-b border-border bg-background px-4 py-3.5 ${className}`}>
      <div className="flex min-w-0 flex-wrap items-center gap-2">{children}</div>
      {end && <div className="flex shrink-0 flex-wrap items-center gap-2">{end}</div>}
    </div>
  )
}

export function SearchInput({ value, onChange, placeholder = 'Search…', className = '', autoFocus, inputProps }: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  className?: string
  autoFocus?: boolean
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}) {
  return (
    <label className={`flex h-[34px] w-[min(340px,100%)] items-center gap-2 rounded-[2px] border border-border bg-card px-2.5 text-subtle focus-within:border-primary ${className}`}>
      <Search className="h-3.5 w-3.5 shrink-0" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="min-w-0 flex-1 bg-transparent text-small text-foreground outline-none placeholder:text-subtle"
        {...inputProps}
      />
      {value && (
        <button type="button" onClick={() => onChange('')} aria-label="Clear" className="flex h-5 w-5 items-center justify-center text-subtle hover:text-foreground"><X className="h-3 w-3" /></button>
      )}
    </label>
  )
}
